// SPDX-License-Identifier: AGPL-3.0-or-later

import chessIcon from '@app/assets/images/table_games/chess.webp';
import damaIcon from '@app/assets/images/table_games/dama.webp';
import damaNormalIcon from '@app/assets/images/table_games/dama_normal.webp';
import okeyIcon from '@app/assets/images/table_games/okey.webp';
import okey101Icon from '@app/assets/images/table_games/okey101.webp';
import type {TableGameKind} from '@fluxer/schema/src/domains/table_game/TableGameSchemas';

// The 3D piece of each game, drawn on the game cards. A game without one shows its name alone.
export const TABLE_GAME_ICONS: Partial<Record<TableGameKind, string>> = {
	chess: chessIcon,
	dama: damaIcon,
	dama_normal: damaNormalIcon,
	okey: okeyIcon,
	okey101: okey101Icon,
};
